import React, { useState } from 'react'
import commaNumber from "comma-number"
import { withNamespaces } from "react-i18next"
import { compose } from 'redux'
import './price_range.scss'
import CurrencyHelper from "../../helpers/currency_helper"
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const WhenDontCheckinCheckout: React.FC = ({min_price: minPrice, max_price: maxPrice, t}) => {
  const currencySymbol = CurrencyHelper.getSymbolFromSelectedCurrency()
  const hasPrice = minPrice || maxPrice

  let renderHasPrice = (
    <div styleName='price-range'>
      <div styleName='price-min'>
        <span className="notranslate">
          <span styleName="price-unit">{currencySymbol}</span>
          {commaNumber(minPrice)}
        </span>
      </div>
      <div styleName="price-max">
        <span className="notranslate">
          <span styleName="price-unit">～ {currencySymbol}</span>
          {commaNumber(maxPrice)}
        </span>
        <span styleName="price-unit">/{t('search.price_range.per_night')}</span>
      </div>
    </div>
  )

  let renderNoPrice = (
    <React.Fragment>
      <div styleName='no-price'>
        {t('search.price_range.no_valid_pricing')}
      </div>
    </React.Fragment>
  )

  return (
    <div itemProp="priceRange" style={{ width: "100%" }}>
      <div styleName="price-alert">{t('search.price_range.reference_recent_month')}</div>
      {hasPrice
        ? renderHasPrice
        : renderNoPrice}
    </div>
  )
}

const WhenHasCheckinOrCheckout: React.FC = ({accommodation_fee, t}) => {
  const currencySymbol = CurrencyHelper.getSymbolFromSelectedCurrency()
  const minScreen = window.innerWidth <= 768

  const [open, setOpen] = useState(false)
  const toogleTooltip = (e) => {
    e.preventDefault()
    setOpen(!open)
  }

  const PriceTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} title={t('search.price_range.additional_charges')} placement="bottom-end"/>
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      position: 'relative',
      maxWidth: 240,
      top: -10,
      right: minScreen ? 0 : -31,
      fontSize: '12px',
      background: '#fff',
      color: '#333',
      border: '1px solid #ddd',
      borderRadius: '4px',
      lineHeight: '16px',
      fontWeight: '300',
      padding: '16px'
    }
  })

  return (
    <div itemProp="priceRange" styleName='total-accommodation-price'>
      <div styleName='price-total'>
        <span className="notranslate">
          <span styleName="price-unit">{currencySymbol}</span>
          {commaNumber(accommodation_fee)}
        </span>
      </div>
      <div styleName="hint">
        <span styleName="title">{t('search.price_range.about_fee')}</span>
        { minScreen
          ? <PriceTooltip open={open}>
            <span onClick={(e) => toogleTooltip(e)} styleName="icon" className="vs-icon-help-outline"></span>
          </PriceTooltip>
          : <PriceTooltip>
            <span onClick={(e) => toogleTooltip(e)} styleName="icon" className="vs-icon-help-outline"></span>
          </PriceTooltip>
        }
      </div>
    </div>
  )
}

export class PriceRange extends React.Component {

  render() {
    return (
      <React.Fragment>
        {this.props.checkin && this.props.checkout
          ? <WhenHasCheckinOrCheckout accommodation_fee={this.props.accommodation_fee} t={this.props.t} />
          : <WhenDontCheckinCheckout min_price={this.props.min_price} max_price={this.props.max_price} t={this.props.t} />
        }
      </React.Fragment>
    )
  }
}

export default compose( withNamespaces('search') )(PriceRange)
